import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _1845fa09 = () => interopDefault(import('../pages/all-centers.vue' /* webpackChunkName: "pages/all-centers" */))
const _5d8ac67f = () => interopDefault(import('../pages/edit-profile.vue' /* webpackChunkName: "pages/edit-profile" */))
const _5a65eded = () => interopDefault(import('../pages/invited-users.vue' /* webpackChunkName: "pages/invited-users" */))
const _8e6962c0 = () => interopDefault(import('../pages/login.vue' /* webpackChunkName: "pages/login" */))
const _0a84bb14 = () => interopDefault(import('../pages/reset-pwd.vue' /* webpackChunkName: "pages/reset-pwd" */))
const _314afa4f = () => interopDefault(import('../pages/trial-admin.vue' /* webpackChunkName: "pages/trial-admin" */))
const _2eec6a14 = () => interopDefault(import('../pages/trials.vue' /* webpackChunkName: "pages/trials" */))
const _271d39a8 = () => interopDefault(import('../pages/anonymization/all-anonymization-configs.vue' /* webpackChunkName: "pages/anonymization/all-anonymization-configs" */))
const _26681f11 = () => interopDefault(import('../pages/clinical-trial/all-clinical-trials.vue' /* webpackChunkName: "pages/clinical-trial/all-clinical-trials" */))
const _70d29914 = () => interopDefault(import('../pages/clinical-trial/upload/_id.vue' /* webpackChunkName: "pages/clinical-trial/upload/_id" */))
const _6590fc66 = () => interopDefault(import('../pages/anonymization/_id.vue' /* webpackChunkName: "pages/anonymization/_id" */))
const _803ead40 = () => interopDefault(import('../pages/clinical-trial/_id.vue' /* webpackChunkName: "pages/clinical-trial/_id" */))
const _21b8a8ee = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/all-centers",
    component: _1845fa09,
    name: "all-centers"
  }, {
    path: "/edit-profile",
    component: _5d8ac67f,
    name: "edit-profile"
  }, {
    path: "/invited-users",
    component: _5a65eded,
    name: "invited-users"
  }, {
    path: "/login",
    component: _8e6962c0,
    name: "login"
  }, {
    path: "/reset-pwd",
    component: _0a84bb14,
    name: "reset-pwd"
  }, {
    path: "/trial-admin",
    component: _314afa4f,
    name: "trial-admin"
  }, {
    path: "/trials",
    component: _2eec6a14,
    name: "trials"
  }, {
    path: "/anonymization/all-anonymization-configs",
    component: _271d39a8,
    name: "anonymization-all-anonymization-configs"
  }, {
    path: "/clinical-trial/all-clinical-trials",
    component: _26681f11,
    name: "clinical-trial-all-clinical-trials"
  }, {
    path: "/clinical-trial/upload/:id?",
    component: _70d29914,
    name: "clinical-trial-upload-id"
  }, {
    path: "/anonymization/:id?",
    component: _6590fc66,
    name: "anonymization-id"
  }, {
    path: "/clinical-trial/:id?",
    component: _803ead40,
    name: "clinical-trial-id"
  }, {
    path: "/",
    component: _21b8a8ee,
    name: "index"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
